/**
 * Gmail Migration API Schemas
 */

import { z } from "zod";

export const GmailDeploymentStatusSchema = z.object({
  deploymentId: z.string(),
  deploymentName: z.string(),
  organizationId: z.string(),
  connectionId: z.string(),
  accountEmail: z.string(),
  currentWebhookUrl: z.string().nullable(),
  expectedWebhookUrl: z.string(),
  needsMigration: z.boolean(),
  watchExpires: z.coerce.date().nullable() // API returns string, coerce to Date
});

export const GmailMigrationStatusResponseSchema = z.object({
  total: z.number(),
  needsMigration: z.number(),
  alreadyMigrated: z.number(),
  deployments: z.array(GmailDeploymentStatusSchema),
  /**
   * Pub/Sub ground truth, read live from Google on every status request.
   *
   * The per-deployment `currentWebhookUrl` is `OAuthConnection.webhookNotificationUrl`
   * — what *we* recorded. This is what Google is actually pushing to, which is the
   * only thing that decides whether a Gmail notification arrives. The handler has
   * sent both since the Pub/Sub diagnostics landed; this schema did not declare
   * them, so the generated client stripped them on parse and the diagnostic was
   * unreachable from the admin panel it was built for.
   *
   * `pubsubSubscriptionName` is null when `WEBHOOK_GMAIL_PUBSUB_SUBSCRIPTION` is
   * unset; `pubsubActualPushEndpoint` is additionally null when the lookup fails.
   */
  pubsubSubscriptionName: z.string().nullable(),
  pubsubActualPushEndpoint: z.string().nullable()
});

export const MigrateGmailWebhookBodySchema = z.object({
  connectionId: z.string().uuid()
});

export const MigrateGmailWebhookResponseSchema = z.object({
  success: z.boolean(),
  webhookUrl: z.string().optional(),
  expiresAt: z.coerce.date().optional(), // API returns string, coerce to Date
  pubsubUpdated: z.boolean().optional(), // Whether Pub/Sub subscription was updated
  error: z.string().optional()
});
